import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { resources } from "./constants/resources";

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: "fr",
    detection: {
      order: ["navigator"],
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

// biome-ignore lint/style/noDefaultExport: <explanation>
export default i18n;
